module.exports = __webpack_public_path__ + "media/images/lp_consultation/merit05-d129dd75cb92564654eb14543ddc5e14.jpg";